export const UTILITIES = {
  eden: 'EDEN',
  edes: 'EDES',
  edelap: 'EDELAP',
  edet: 'EDET',
  ejesa: 'EJESA',
  utilityco: 'UTILITYCO'
};
